var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    containerBorderColor: colors.tiara,
    pastDueColor: colors.crimson,
    containerPadding: spacing.xSmall,
    iconWrapperMargin: spacing.xSmall
  };
};
export default generateComponentTheme;